import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { useParams, useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumb";
import VendorCategoryService from "../../services/VendorCategoryService";
import StorageService from "../../services/StorageService";
import MessageDialog from "../../components/MessageDialog";

export default function AddVendorCategory() {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  const { id } = useParams();
  // const messageTimer = useRef(null);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    // const editData = JSON.parse(localStorage.getItem("editVendorCategory"));
    const loadCategory = async () => {
      if (!id) return;
      setEditMode(true);
      setEditId(id);
      try {
        const res = await VendorCategoryService.getById(id);
        if (res.status === "true" && res.data) {
          const cat = res.data;

          setValue("vendorCategoryName", cat.vendorCategoryName);
          setValue("vendorCategoryCode", cat.vendorCategoryCode);
          setValue("status", cat.status || "Active");
        } else {
          console.error("Invalid API response:", res);
        }
      } catch (err) {
        console.error("Error loading vendor category:", err);
      }
    };

    loadCategory();
  }, [id, setValue]);

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  const onSubmit = async (data) => {
    setLoading(true);

    try {
      let res;

      if (editMode && editId) {
        data.updatedBy = StorageService.loginData().employeeId;
        res = await VendorCategoryService.update(editId, data);
      } else {
        data.createdBy = StorageService.loginData().employeeId;
        data.status = "Active";
        res = await VendorCategoryService.create(data);
      }


      if (res?.status === "true") {
        showMessage(
          editMode
            ? "Vendor Category updated successfully."
            : "Vendor Category added successfully.",
          "success"
        );

        setTimeout(() => navigate("/cpnl/vendorcategory/view"), 1000);
      } else {
        showMessage(res?.message || "Error saving Vendor Category.", "error");
      }

    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        "Error saving vendor category";

      showMessage(msg, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    localStorage.removeItem("editVendorCategory");
    navigate("/cpnl/vendorcategory/view");
  };

  return (
    <>
      <Breadcrumb
        pageTitle={editMode ? "Modify Vendor Category" : "Add Vendor Category"}
        secondTitle="Masters"
      />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center mb-3 p-2`}
            >
              <span>{message}</span>
              <button
                type="button"
                className="btn-close"
                onClick={() => setMessage("")}
              />
            </div>
          )} */}
          
            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row mb-3">
              {/* Vendor Category Name */}
              <div className="col-md-6">
                <label className="form-label">
                  Vendor Category Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.vendorCategoryName ? "is-invalid" : ""
                    }`}
                  placeholder="Enter Vendor Category Name"
                  disabled={loading}
                  {...register("vendorCategoryName", {
                    required: "Vendor category name is required",
                    minLength: {
                      value: 2,
                      message: "Minimum 2 characters required",
                    },
                  })}
                />
                {errors.vendorCategoryName && (
                  <small className="text-danger">
                    {errors.vendorCategoryName.message}
                  </small>
                )}
              </div>

              {/* Vendor Category Code */}
              <div className="col-md-6">
                <label className="form-label">
                  Vendor Category Code <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  className={`form-control ${errors.vendorCategoryCode ? "is-invalid" : ""
                    }`}
                  placeholder="Enter Code"
                  disabled={loading}
                  {...register("vendorCategoryCode", {
                    required: "Vendor category code is required",
                    minLength: {
                      value: 1,
                      message: "Minimum 1 character required",
                    },
                  })}
                  onInput={(e) => {
                    if (e.target.value.includes(" ")) {
                      showMessage("Vendor Category Code should not contain spaces", "error");
                      e.target.value = e.target.value.replace(/\s/g, "");
                    }

                    e.target.value = e.target.value.toUpperCase();
                  }}
                />
                {errors.vendorCategoryCode && (
                  <small className="text-danger">
                    {errors.vendorCategoryCode.message}
                  </small>
                )}
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-sm me-2"
              disabled={loading}
            >
              <i className="ti ti-circle-check me-1"></i>
              {loading
                ? editMode
                  ? "Updating..."
                  : "Saving..."
                : editMode
                  ? "Update"
                  : "Save"}
            </button>

            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={handleCancel}
              disabled={loading}
            >
              <i class="ti ti-cancel me-1"></i>
              Cancel
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
